export const TicketStandardTemplate = {
  id: 3,
  name: "Ticket Standard",
  description: "Ticket standard pour les clients",
  variables: [
    { key: "datee", label: "Date", default: new Date().toLocaleDateString() },
    { key: "clientName", label: "Nom du client", default: "" },
    { key: "ticketNumber", label: "Numéro du ticket", default: "" },
  ],
  is_default: true,
  type: "ticket",
  reference: "ticket-standard-1",
}
